import React, { useEffect, useState } from 'react';
import { MinifiedTableOfContent } from 'libs/growth-platform-brand-system-v2/src/components/TableOfContent/MinifiedTableOfContent';
import {
  track,
  getGoogleAnalyticsId,
} from 'libs/growth-platform-brand-system-v2/src/utils/tracking';

export const scrollToHeading = (title?: string) => {
  if (!title) return '';
  const headingId = title?.replace(/\W+/g, '-');
  return `#${headingId}`;
};

export const _handleActiveHeading = (
  headingElementsRef: any,
  activeHeadingTitle: string | undefined,
  setActiveHeadingTitle: any,
): void => {
  if (typeof window === 'undefined') return;
  const windowHeight = window.innerHeight;
  const headingArray = Object.values(headingElementsRef.current);
  const h2Array: any = headingArray.filter(
    (heading: any) => heading.tagName === 'H2',
  );

  for (let i = 0; i < h2Array.length; i++) {
    const heading = h2Array[i];
    const rect = heading.getBoundingClientRect();
    const fromViewportBottom = windowHeight - rect.top;

    if (
      window.location.hash === scrollToHeading(activeHeadingTitle) &&
      h2Array?.[0]?.getBoundingClientRect()?.top > 0
    )
      break;
    if (
      (fromViewportBottom >= 250 && fromViewportBottom <= windowHeight) ||
      (rect.top <= 0 && rect.bottom >= 0)
    ) {
      if (heading.textContent) {
        setActiveHeadingTitle(heading.textContent.trim());
        break;
      }
    }
  }
};

export const _handleHeadingChange = (
  title: string,
  setActiveHeadingTitle: any,
) => {
  if (typeof window !== 'undefined') {
    setActiveHeadingTitle(title);

    track({
      gtm: {
        event: 'Toggle Interaction',
        properties: {
          componentName: 'MinifiedTableOfContent',
          toggleLabel: `${title}`,
          gaClientID: getGoogleAnalyticsId(),
        },
      },
    });

    window.location.hash = '';
    window.location.hash = scrollToHeading(title);
  }
};

export const TableOfContentComponent = ({
  headings,
  block,
  headingElementsRef,
  className,
}: any) => {
  const initialHeading = headings[0]?.title ?? '';
  const [activeHeadingTitle, setActiveHeadingTitle] =
    useState<string>(initialHeading);

  const optionsHeadings = headings.map((heading: any) => ({
    label: heading.title,
    value: heading.title,
  }));

  const handleHeadingChange = (title: string) =>
    _handleHeadingChange(title, setActiveHeadingTitle);

  useEffect(() => {
    const handleScroll = () => {
      _handleActiveHeading(
        headingElementsRef,
        activeHeadingTitle,
        setActiveHeadingTitle,
      );
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [activeHeadingTitle, headingElementsRef]);

  return (
    <MinifiedTableOfContent
      title={block.title}
      options={optionsHeadings}
      valueSelected={activeHeadingTitle ?? ''}
      onChange={handleHeadingChange}
      className={className}
    />
  );
};

export default TableOfContentComponent;
